import { createAction, type QueuedAction } from "@/v2/hooks/useActionQueue";
import { apiCall, type ActionDeps } from "./types";

export type AddPayload = {
	id: number;
	date: string;
	matter: string;
	matter_id: string;
	description: string;
	duration: number;
	task: string;
	activity: string;
	end_time: string;
};

export function addAction(entry: AddPayload, deps: ActionDeps): QueuedAction {
	return createAction({
		execute: () =>
			apiCall(deps, {
				endpoint: "/records/add",
				method: "POST",
				body: entry,
			}),
		rollback: null,
		toast: {
			loading: "Adding entry\u2026",
			success: "Entry added",
			error: "Failed to add entry",
		},
		onSuccess: () => deps.refreshRecords(),
		onError: () => deps.refreshRecords(),
	});
}
